"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANT_MARK = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var locale_1 = require("../_components/_modal/locale");
// import { PopconfirmLocale } from '../popconfirm';
// import { UploadLocale } from '../upload/interface';
// import { TransferLocale } from '../transfer';
var context_1 = tslib_1.__importDefault(require("./context"));
exports.ANT_MARK = 'internalMark';
var LocaleProvider = /** @class */ (function (_super) {
    tslib_1.__extends(LocaleProvider, _super);
    function LocaleProvider(props) {
        var _this = _super.call(this, props) || this;
        (0, locale_1.changeConfirmLocale)(props.locale && props.locale.Modal);
        return _this;
    }
    LocaleProvider.prototype.componentDidUpdate = function (prevProps) {
        var locale = this.props.locale;
        if (prevProps.locale !== locale) {
            (0, locale_1.changeConfirmLocale)(locale && locale.Modal);
        }
    };
    LocaleProvider.prototype.componentWillUnmount = function () {
        (0, locale_1.changeConfirmLocale)();
    };
    LocaleProvider.prototype.render = function () {
        var _a = this.props, locale = _a.locale, children = _a.children;
        return (React.createElement(context_1.default.Provider, { value: tslib_1.__assign(tslib_1.__assign({}, locale), { exist: true }) }, children));
    };
    LocaleProvider.defaultProps = {
        locale: {},
    };
    return LocaleProvider;
}(React.Component));
exports.default = LocaleProvider;
//# sourceMappingURL=index.js.map